<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Formaty na wyjściu - <strong>{{ productComponent.calculationProductComponentName }}</strong>
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-mask="'######'"
                            :value="productComponent.outputFormatA"
                            label="Format A"
                            suffix="mm"
                            outlined
                            dense
                            hide-details
                            @change="changeOutputFormatA"
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-mask="'######'"
                            :value="productComponent.outputFormatB"
                            label="Format B"
                            suffix="mm"
                            outlined
                            dense
                            hide-details
                            @change="changeOutputFormatB"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mask } from 'vue-the-mask'
import parse from '@/mixins/parse'

export default {
    name: 'SlicingFormatsDialog',
    directives: { mask },
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        productComponentData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            productComponent: {}
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.productComponent = JSON.parse(JSON.stringify(this.productComponentData))
            } else {
                setTimeout(() => {
                    this.productComponent = {}
                }, 500)
            }
        }
    },
    methods: {
        changeOutputFormatA(value) {
            this.productComponent.outputFormatA = this.parseEmptyStringToNull(value)
        },
        changeOutputFormatB(value) {
            this.productComponent.outputFormatB = this.parseEmptyStringToNull(value)
        },
        onSave() {
            this.$emit('on-save', this.productComponent)
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>